<div class="bg-card rounded-[20px] shadow-lg p-5 w-full max-w-md border border-gray-100 dark:border-foreground-tertiary dark:bg-card">
  <!-- Header -->
  <div class="flex items-center justify-between mb-2">
      <h3 class="text-foreground text-[18px] font-semibold tracking-tight">Assessment Score</h3>
      <div class="w-8 h-8 rounded-full border border-gray-200 dark:border-gray-700 flex items-center justify-center cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
               stroke="#4B5563" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
      </div>
  </div>

  <div class="flex items-end justify-between mt-6">
      <!-- Left Content -->
      <div class="mb-2">
          <div class="inline-block px-3 py-1 rounded-lg text-sm font-medium" [ngClass]="scoreBadgeClass">
              {{ scoreLabel }}
          </div>

          <p class="text-sm font-medium mt-4 flex items-center gap-1.5"
             [ngClass]="isPositive ? 'text-green-600' : 'text-red-500'">
              <svg *ngIf="isPositive" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                  <polyline points="16 7 22 7 22 13"></polyline>
              </svg>
              <svg *ngIf="!isPositive" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="22 17 13.5 8.5 8.5 13.5 2 7"></polyline>
                  <polyline points="16 17 22 17 22 11"></polyline>
              </svg>
              <span>{{ isPositive ? '+' : '-' }}{{ progress }}%</span>
              <span class="text-gray-500 font-normal">vs last assessment</span>
          </p>

          <p class="text-[13px] text-gray-500 mt-2">Latest Assessment: {{ date }}</p>
      </div>

      <!-- Right Gauge -->
      <div class="flex flex-col items-center justify-center flex-shrink-0 relative w-[160px] h-[90px] mr-2">
          <svg viewBox="0 0 100 68" class="w-full h-full overflow-visible">
              <defs>
                  <linearGradient id="mainGaugeGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%"   stop-color="#EF4444"/>
                      <stop offset="30%"  stop-color="#F97316"/>
                      <stop offset="58%"  stop-color="#EAB308"/>
                      <stop offset="100%" stop-color="#22C55E"/>
                  </linearGradient>
              </defs>

              <g stroke-linecap="round" stroke-width="1.3">
                  <line x1="3.5"  y1="58.0" x2="0.0"  y2="58.0" stroke="#EF4444"/>
                  <line x1="5.8"  y1="43.6" x2="1.3"  y2="42.1" stroke="#EF4444"/>
                  <line x1="12.4" y1="30.6" x2="8.0"  y2="28.3" stroke="#F97316"/>
                  <line x1="22.7" y1="20.5" x2="19.7" y2="17.8" stroke="#F97316"/>
                  <line x1="35.6" y1="13.7" x2="34.1" y2="9.6"  stroke="#EAB308"/>
                  <line x1="50.0" y1="11.5" x2="50.0" y2="6.5"  stroke="#EAB308"/>
                  <line x1="64.4" y1="13.7" x2="65.9" y2="9.6"  stroke="#84CC16"/>
                  <line x1="77.3" y1="20.5" x2="80.3" y2="17.8" stroke="#84CC16"/>
                  <line x1="87.6" y1="30.6" x2="92.0" y2="28.3" stroke="#22C55E"/>
                  <line x1="94.2" y1="43.6" x2="98.7" y2="42.1" stroke="#22C55E"/>
                  <line x1="96.5" y1="58.0" x2="100"  y2="58.0" stroke="#22C55E"/>
              </g>

              <!-- Background arc -->
              <path
                  d="M 8,58 A 42,42 0 0,1 92,58"
                  fill="none"
                  stroke="#F3F4F6"
                  class="dark:stroke-gray-800"
                  stroke-width="8"
                  stroke-linecap="round"
              />

              <!-- Gradient progress arc -->
              <path
                  d="M 8,58 A 42,42 0 0,1 92,58"
                  fill="none"
                  stroke="url(#mainGaugeGrad)"
                  stroke-width="8"
                  stroke-linecap="round"
                  style="transition: stroke-dasharray 1s ease-in-out;"
                  [style.stroke-dasharray]="strokeDashArray"
              />
          </svg>

          <!-- Score text -->
          <div class="absolute bottom-1 left-0 right-0 flex flex-col items-center text-center">
              <span class="text-3xl font-extrabold text-[#111827] dark:text-white leading-none tracking-tight">
                  {{ (score | number:'1.0-0') || 0 }}
              </span>
              <span class="text-[11px] text-gray-500 font-medium tracking-wide mt-0.5">out of 100</span>
          </div>

           <!-- Start/End Ticks Text -->
          <div class="absolute bottom-[-16px] left-[-2px]">
            <span class="text-[10px] text-gray-400 font-medium">0</span>
          </div>
          <div class="absolute bottom-[-16px] right-[-4px]">
            <span class="text-[10px] text-gray-400 font-medium">100</span>
          </div>
      </div>
  </div>
</div>
